import { Component } from '@angular/core';

@Component({
  selector: 'app-section-previa-projeto',
  templateUrl: './section-previa-projeto.component.html',
  styleUrls: ['./section-previa-projeto.component.scss'],
})
export class SectionPreviaProjetoComponent {}
